import React from 'react';

import { Feature } from 'config/features';

import { useFeature } from 'hooks/useFeature';

import { ConditionalWrapper } from 'utility/Check/ConditionalWrapper';

import DebounceFilterProvider from './DebounceFilterProvider';

export interface DebounceProviderWrapperProps {
    children: React.ReactNode;
}

const DebounceProviderWrapper = ({
    children,
}: DebounceProviderWrapperProps) => {
    const isFeatureActive = useFeature(Feature.ManualFilterSubmit);
    return (
        <ConditionalWrapper
            condition={!isFeatureActive}
            wrapper={(children: React.ReactElement) => (
                <DebounceFilterProvider>{children}</DebounceFilterProvider>
            )}
        >
            <span>{children}</span>
        </ConditionalWrapper>
    );
};

export default DebounceProviderWrapper;
